<template>
  <v-container class="pa-0 ma-0 industry-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <div class="industry-text">
      <p>
        If you want to help us create more impact in the society, you can
        sponsor one of our programs, and contribute financially or in-kind to
        our development.
      </p>
      <p>
        We are open to listen to your needs and design programs that may
        positively impact your organization and society at large.
      </p>
      <p>Take part of our journey! Reach out using the form below.</p>
      <ContactForm />
    </div>
  </v-container>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
  name: 'Sponsorship',
  components: {
    ContactForm,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
